<!--
 * @Description: 暂无数据时显示图片占位组件
 * @Autor: txp
 * @Date: 2021-05-21 11:35:22
-->
<template>
    <div class="empty">
        <div :class="'empty_img'" :style="{'height':Htmlheight,'width':Htmlwidth}">
            <p>{{title}}</p>
        </div>
    </div>
</template>
<script>
import NoImg from '../../assets/img/no_goods.png'
export default{
    props:{
        title:{
            type:String,
            default:"暂无"
        },
        Htmlwidth:{
            type:String,
            default:"100px" 
        },
        Htmlheight:{
            type:String,
            default:"100px" 
        }
    },   
    data(){
        return {
            NoImg
        }
    }
}
</script>

<style lang="scss" scoped>
    .empty{
        .empty_img{
            position: relative;
            color: #c5c5c5;
            margin: auto;
            background: url("../../assets/img/no_goods.png") no-repeat center center;
            background-size:100% 100%;
            p{
                position: absolute;
                bottom: 20%;
                left: 50%;
                transform: translate(-50%);
            }
        }
    }
</style>
